import { Select as MantineSelect } from "@mantine/core"
import styled from "styled-components"

import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

export const Select = styleWithOrgDesign(styled(MantineSelect)`
    width: 100%;

    font-size: 14px;
    color: var(--custom-font-color);
    border-color: var(--custom-border-color);

    & .mantine-Select-input {
        border-radius: 8px;
        background-color: white;
        color: black;

        min-height: 48px;
    }

    & .mantine-Input-rightSection svg {
        color: var(--custom-font-color) !important;
    }
`)
